(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();


    function setYoutubeVideoClass() {
        // get list
        var youtubeVideoList = $('._don-youtubevideo__container');

        youtubeVideoList.each(function () {

            var $youtubeVideo = $(this);

            var $iframeSet = $youtubeVideo.find('iframe');

            $iframeSet.each(function () {

                var $iframe = $(this);

                var $iframe = $iframe.addClass('_don-youtubevideo__youtubevideo');
            });            
        });
    }

    $(document).ready(setYoutubeVideoClass);

    document.addEventListener("DOMContentLoaded", function () {
        var target = document.getElementsByClassName("_don-youtubevideo__container")[0];
        
        if (!target) return;

        var observer = new MutationObserver(function (mutationsList) {
            for (var i = 0; i < mutationsList.length; i++) {
                var mutation = mutationsList[i];
                if (mutation.type === "childList") {
                    var nodes = mutation.addedNodes;
                    for (var j = 0; j < nodes.length; j++) {
                        var node = nodes[j];
                        if (node.tagName === "IFRAME" && node.src.includes("youtube.com")) {
                            setYoutubeVideoClass();
                            observer.disconnect();
                            return;
                        }
                    }
                }
            }
        });

        observer.observe(target, { childList: true, subtree: true });
    });

})(window, document, jQuery);
